export const leadershipConfig = {
  uae: {
    videoUrl: "https://www.youtube.com/embed/mGK035nCbLI",
  },
};
